module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-week"
  }, [_vm._l((_vm.days), function(day, i) {
    return [_c('ds-day', _vm._g(_vm._b({
      key: i,
      attrs: {
        "day": day,
        "calendar": _vm.calendar,
        "placeholder": _vm.placeholder,
        "placeholder-for-create": _vm.placeholderForCreate
      }
    }, 'ds-day', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb16c334","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DayRow.vue
// module id = 190
// module chunks = 0